// src/main/VacancyManagement.js

import React, { useState, useEffect } from 'react';
import {
    Container,
    Typography,
    Button,
    Paper,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Box,
    Chip,
    Grid,
    Slide,
    MenuItem,
    InputLabel,
    FormControl,
    Select,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TablePagination,
    Divider,
    useTheme,
    InputAdornment,
    Menu,
    Tooltip,
    Card,
    CardContent,
    CardActions,
    Avatar,
    Tabs,
    Tab,
    Alert,
    Snackbar,
    FormControlLabel,
    Switch,
    CircularProgress,
    LinearProgress,
    Stepper,
    Step,
    StepLabel,
    Badge,
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Rating,
    Fab,
    Zoom,
    Breadcrumbs,
    Link,
    StepConnector,
    stepConnectorClasses,
    styled
} from '@mui/material';
import {
    Delete,
    Search,
    Add as AddIcon,
    Close as CloseIcon,
    Filter as FilterIcon,
    Refresh as RefreshIcon,
    Edit as EditIcon,
    Visibility as ViewIcon,
    PictureAsPdf,
    TableChart,
    GetApp,
    Print,
    CheckCircle,
    Cancel,
    People,
    AttachMoney,
    Email as EmailIcon,
    Send,
    Download,
    Receipt as ReceiptIcon,
    ReceiptLong,
    Pending,
    Error as ErrorIcon,
    Verified,
    Schedule,
    CloudDownload,
    LocalPrintshop,
    QrCodeScanner,
    History,
    CheckCircleOutline,
    Warning,
    Info,
    Phone,
    Person,
    Business,
    Home,
    CalendarToday,
    Description,
    Note,
    AttachFile,
    CloudUpload,
    AccountBalance,
    TrendingUp,
    TrendingDown,
    Calculate,
    Adjust,
    LocalAtm,
    MoneyOff,
    VerifiedUser,
    Balance,
    Receipt,
    EventNote,
    AssignmentInd,
    KeyboardArrowDown,
    KeyboardArrowUp,
    Summarize,
    MeetingRoom,
    Build,
    CleaningServices,
    HomeRepairService,
    AdsClick,
    Facebook,
    Google,
    Instagram,
    Twitter,
    Campaign,
    Visibility as VisibilityIcon,
    Assessment,
    Timeline,
    DateRange,
    Today,
    Weekend,
    BedroomParent,
    Bathroom,
    SquareFoot,
    LocationCity,
    Apartment,
    DoneAll,
    Clear,
    PlaylistAddCheck,
    Inventory,
    ReportProblem,
    Star,
    StarBorder,
    TrendingFlat,
    AccessTime,
    WatchLater,
    HourglassEmpty,
    MoveToInbox,
    CheckBox,
    RadioButtonChecked,
    TaskAlt,
    AddCircleOutlineOutlined
} from '@mui/icons-material';
import { motion } from 'framer-motion';
import useCustomToast from '../../hooks/useToast';
import {
    APIPropertyList,
    APIPropertyVacancyList,
    APIVacancyList,
    APIVacancyStore,
    APIVacancyUpdate,
    APIVacancyDelete,
    APIVacancyExportExcel,
    APIVacancyExportPDF,
    APIVacancyPrint,
    APIVacancyStats,
    APIVacancyMarkReady,
    APIVacancyUpdateStatus
} from '../../apiServices/APIs';
import { formatCreatedAtDate, recordsCount, recordsPerPage } from '../../utils/helpers';
import { getUserDetails } from '../../utils/helpers';
import { apiService } from '../../apiServices/ApiService';
import ErrorState from '../../components/ErrorrState';
import LoadingState from '../../components/LoadingState';
import { usePermission } from '../../hooks/usePermission';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const VacancyManagement = () => {
    const theme = useTheme();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const showToast = useCustomToast();
    const [updateId, setUpdateId] = useState('');
    const [postStatus, setPostStatus] = useState('ADD');
    const [exportAnchorEl, setExportAnchorEl] = useState(null);
    const [pageState, setPageState] = useState({
        pageData: [],
    });
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(recordsPerPage);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [activeTab, setActiveTab] = useState(0);
    const [statistics, setStatistics] = useState(null);
    const [properties, setProperties] = useState([]);
    const [statusUpdateDialogOpen, setStatusUpdateDialogOpen] = useState(false);
    const [newStatus, setNewStatus] = useState('');
    const [readyDialogOpen, setReadyDialogOpen] = useState(false);
    const [readyItems, setReadyItems] = useState({
        cleaning_completed: false,
        repairs_completed: false
    });

    // Advertised platforms
    const advertisedPlatforms = [
        { id: 'zillow', name: 'Zillow', icon: <Home />, color: 'primary' },
        { id: 'facebook', name: 'Facebook Marketplace', icon: <Facebook />, color: 'info' },
        { id: 'instagram', name: 'Instagram', icon: <Instagram />, color: 'error' },
        { id: 'twitter', name: 'Twitter', icon: <Twitter />, color: 'info' },
        { id: 'google', name: 'Google Ads', icon: <Google />, color: 'success' },
        { id: 'local', name: 'Local Listing', icon: <LocationCity />, color: 'warning' },
        { id: 'agent', name: 'Real Estate Agent', icon: <Person />, color: 'secondary' },
        { id: 'website', name: 'Company Website', icon: <Campaign />, color: 'primary' }
    ];

    // Vacancy status options
    const vacancyStatusOptions = [
        { id: 'listing', name: 'Listing', color: 'info', icon: <AdsClick />, step: 1 },
        { id: 'showing', name: 'Showing', color: 'warning', icon: <VisibilityIcon />, step: 2 },
        { id: 'pending_lease', name: 'Pending Lease', color: 'primary', icon: <AssignmentInd />, step: 3 },
        { id: 'filled', name: 'Filled', color: 'success', icon: <TaskAlt />, step: 4 }
    ];

    // Form data for Vacancy
    const [formData, setFormData] = useState({
        property_id: '',
        date_became_vacant: new Date().toISOString().split('T')[0],
        advertised_on: '',
        move_in_ready: false,
        cleaning_completed: false,
        repairs_completed: false,
        vacancy_status: 'listing',
        notes: '',
        market_price: ''
    });

    const [filters, setFilters] = useState({
        vacancy_status: '',
        property_id: '',
        move_in_ready: '',
        date_from: '',
        date_to: '',
        days_on_market_min: '',
        days_on_market_max: ''
    });

    const [errors, setErrors] = useState({
        property_id: false,
        date_became_vacant: false
    });

    // State for dialogs
    const [filterOptions, setFilterOptions] = useState(false);
    const [openAdd, setOpenAdd] = useState(false);
    const [openView, setOpenView] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

    const { hasPermission, loading: permissionLoading } = usePermission();

    useEffect(() => {
        apiService.setToastFunction(showToast);
        fetchProperties();
        fetchVacancies();
        fetchStatistics();
    }, [showToast]);

    // Fetch properties for dropdown
    const fetchProperties = async () => {
        try {
            const userBranchId = getUserDetails("branchId");
            const result = await apiService.list(userBranchId, APIPropertyList);
            if (result.success) {
                setProperties(Array.isArray(result.data) ? result.data : []);
            }
        } catch (error) {
            console.error("Error fetching properties:", error);
        }
    };

    // Fetch vacancies
    const fetchVacancies = async () => {
        setLoading(true);
        setError(null);
        try {
            const userBranchId = getUserDetails("branchId");
            const result = await apiService.list(userBranchId, APIVacancyList);

            if (result.success) {
                const vacancies = Array.isArray(result.data) ? result.data.reverse() : [];
                setPageState(prev => ({
                    ...prev,
                    pageData: vacancies
                }));
            } else {
                setError(result.message);
            }
        } catch (error) {
            setError("Failed to load data");
            console.error("Fetch error:", error);
        } finally {
            setLoading(false);
        }
    };

    // Fetch statistics
    const fetchStatistics = async () => {
        try {
            const userBranchId = getUserDetails("branchId");
            const result = await apiService.listStats(userBranchId, APIVacancyStats);
            if (result.success && result.data) {
                setStatistics(result.data);
            }
        } catch (error) {
            console.error("Error fetching statistics:", error);
        }
    };

    // Export handlers
    const handleExportClick = (event) => { setExportAnchorEl(event.currentTarget); };
    const handleExportClose = () => { setExportAnchorEl(null); };
    
    const handlePrintVacancy = async (record) => {
        if (!hasPermission('EXPORT')) {
            showToast("Permission Denied", "You don't have permission to print vacancy details", "error");
            return;
        }
        
        try {
            const formDataToSend = new FormData();
            formDataToSend.append('print_id', record.id);
            formDataToSend.append('user_name', getUserDetails("userName"));
            formDataToSend.append('branch_id', getUserDetails("branchId"));
            formDataToSend.append('user_id', getUserDetails("Id"));

            const result = await apiService.print(APIVacancyPrint, formDataToSend);
            if (result && result.success) {
                showToast("Success", "PDF file generated successfully", "success");
            } else {
                showToast("Error", result.message || "Failed to generate PDF file", "error");
            }
        } catch (error) {
            console.error("Print error:", error);
            showToast("Error", "Failed to generate PDF file", "error");
        }
    };
    
    const handleExportExcel = async () => {
        if (!hasPermission('EXPORT')) {
            showToast("Permission Denied", "You don't have permission to export vacancy data", "error");
            handleExportClose();
            return;
        }
        
        try {
            handleExportClose();
            showToast("Processing", "Preparing Excel export...", "info");
            const formDataToSend = new FormData();
            formDataToSend.append('branch_id', getUserDetails("branchId"));
            formDataToSend.append('user_id', getUserDetails("Id"));
            const result = await apiService.exportToExcel(APIVacancyExportExcel, formDataToSend);
            if (result && result.success) {
                showToast("Success", "Excel file downloaded successfully", "success");
            } else {
                showToast("Error", result.message || "Failed to export Excel file", "error");
            }
        } catch (error) {
            console.error('Excel export error:', error);
            showToast("Error", error.message || "Failed to export Excel file", "error");
        }
    };

    const handleExportPDF = async () => {
        if (!hasPermission('EXPORT')) {
            showToast("Permission Denied", "You don't have permission to export vacancy data", "error");
            handleExportClose();
            return;
        }
        
        try {
            handleExportClose();
            showToast("Processing", "Preparing PDF export...", "info");

            const formDataToSend = new FormData();
            formDataToSend.append('branch_id', getUserDetails("branchId"));
            formDataToSend.append('user_name', getUserDetails("userName"));
            formDataToSend.append('user_id', getUserDetails("Id"));
            const result = await apiService.exportToPDF(APIVacancyExportPDF, formDataToSend);

            if (result && result.success) {
                showToast("Success", "PDF file downloaded successfully", "success");
            } else {
                showToast("Error", result.message || "Failed to export PDF file", "error");
            }
        } catch (error) {
            console.error('PDF export error:', error);
            showToast("Error", error.message || "Failed to export PDF file", "error");
        }
    };

    // Mark apartment as move-in ready
    const handleMarkReady = async () => {
        if (!hasPermission('EDIT')) {
            showToast("Permission Denied", "You don't have permission to mark properties as ready", "error");
            return;
        }

        try {
            const formDataToSend = new FormData();
            formDataToSend.append('user_id', getUserDetails("Id"));
            formDataToSend.append('branch_id', getUserDetails("branchId"));
            formDataToSend.append('vacancy_id', selectedRecord.id);
            formDataToSend.append('cleaning_completed', readyItems.cleaning_completed ? 1 : 0);
            formDataToSend.append('repairs_completed', readyItems.repairs_completed ? 1 : 0);

            const result = await apiService.create(APIVacancyMarkReady, formDataToSend);
            if (result && result.success) {
                showToast("Success", result.message, "success");
                setReadyDialogOpen(false);
                setReadyItems({ cleaning_completed: false, repairs_completed: false });
                fetchVacancies();
                fetchStatistics();
            }
        } catch (error) {
            console.error("Mark ready error:", error);
            showToast("Error", "Failed to mark property as ready", "error");
        }
    };

    // Update vacancy status
    const handleUpdateStatus = async () => {
        if (!hasPermission('EDIT')) {
            showToast("Permission Denied", "You don't have permission to update vacancy status", "error");
            return;
        }

        try {
            const formDataToSend = new FormData();
            formDataToSend.append('user_id', getUserDetails("Id"));
            formDataToSend.append('branch_id', getUserDetails("branchId"));
            formDataToSend.append('vacancy_id', selectedRecord.id);
            formDataToSend.append('vacancy_status', newStatus);

            const result = await apiService.create(APIVacancyUpdateStatus, formDataToSend);
            if (result && result.success) {
                showToast("Success", result.message, "success");
                setStatusUpdateDialogOpen(false);
                setNewStatus('');
                fetchVacancies();
                fetchStatistics();
            }
        } catch (error) {
            console.error("Update status error:", error);
            showToast("Error", "Failed to update vacancy status", "error");
        }
    };

    // Filter handlers
    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const clearFilters = () => {
        setFilters({
            vacancy_status: '',
            property_id: '',
            move_in_ready: '',
            date_from: '',
            date_to: '',
            days_on_market_min: '',
            days_on_market_max: ''
        });
        setSearchTerm('');
        handleCloseOptions();
    };

    const applyFilters = () => {
        handleCloseOptions();
    };

    const handlefilterOptions = () => setFilterOptions(true);
    const handleCloseOptions = () => setFilterOptions(false);
    const handleCloseView = () => setOpenView(false);
    const handleOpenView = (record) => {
        setSelectedRecord(record);
        setOpenView(true);
    };

    // Dialog handlers
    const handleOpenAdd = () => {
        if (!hasPermission('ADD')) {
            showToast("Permission Denied", "You don't have permission to add vacancies", "error");
            return;
        }

        setPostStatus("ADD");
        setFormData({
            property_id: '',
            date_became_vacant: new Date().toISOString().split('T')[0],
            advertised_on: '',
            move_in_ready: false,
            cleaning_completed: false,
            repairs_completed: false,
            vacancy_status: 'listing',
            notes: '',
            market_price: ''
        });
        setErrors({
            property_id: false,
            date_became_vacant: false
        });
        setOpenAdd(true);
    };

    const handleCloseAdd = () => {
        setOpenAdd(false);
    };

    const handleOpenEdit = (record) => {
        if (!hasPermission('EDIT')) {
            showToast("Permission Denied", "You don't have permission to edit vacancies", "error");
            return;
        }

        setSelectedRecord(record);
        setUpdateId(record.id);
        setPostStatus("UPDATE");

        setFormData({
            property_id: record.property_id || '',
            date_became_vacant: record.date_became_vacant || '',
            advertised_on: record.advertised_on || '',
            move_in_ready: record.move_in_ready || false,
            cleaning_completed: record.cleaning_completed || false,
            repairs_completed: record.repairs_completed || false,
            vacancy_status: record.vacancy_status || 'listing',
            notes: record.notes || '',
            market_price: record.market_price || ''
        });
        setOpenAdd(true);
    };

    const handleOpenDelete = (record) => {
        if (!hasPermission('DELETE')) {
            showToast("Permission Denied", "You don't have permission to delete vacancies", "error");
            return;
        }

        setSelectedRecord(record);
        setUpdateId(record.id);
        setPostStatus("DELETE");
        setOpenDelete(true);
    };

    const handleCloseDelete = () => {
        setOpenDelete(false);
    };

    const handleOpenMarkReady = (record) => {
        if (!hasPermission('EDIT')) {
            showToast("Permission Denied", "You don't have permission to mark as ready", "error");
            return;
        }
        setSelectedRecord(record);
        setReadyItems({
            cleaning_completed: record.cleaning_completed || false,
            repairs_completed: record.repairs_completed || false
        });
        setReadyDialogOpen(true);
    };

    const handleOpenStatusUpdate = (record) => {
        if (!hasPermission('EDIT')) {
            showToast("Permission Denied", "You don't have permission to update status", "error");
            return;
        }
        setSelectedRecord(record);
        setNewStatus(record.vacancy_status);
        setStatusUpdateDialogOpen(true);
    };

    // Form handlers
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;

        setErrors(prev => ({
            ...prev,
            [name]: false
        }));

        if (name === 'property_id') {
            const selectedProperty = properties.find(p => p.id.toString() === value);
            if (selectedProperty && !formData.market_price) {
                setFormData(prev => ({
                    ...prev,
                    [name]: value,
                    market_price: selectedProperty.default_rent_amount || ''
                }));
                return;
            }
        }

        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const validateForm = () => {
        if (!formData.property_id) {
            showToast("Validation Error", "Please select a property", "warning");
            return false;
        }
        if (!formData.date_became_vacant) {
            showToast("Validation Error", "Vacant date is required", "warning");
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (postStatus === "ADD" && !hasPermission('ADD')) {
            showToast("Permission Denied", "You don't have permission to add vacancies", "error");
            return;
        }
        
        if (postStatus === "UPDATE" && !hasPermission('EDIT')) {
            showToast("Permission Denied", "You don't have permission to update vacancies", "error");
            return;
        }
        
        if (postStatus === "DELETE" && !hasPermission('DELETE')) {
            showToast("Permission Denied", "You don't have permission to delete vacancies", "error");
            return;
        }
        
        if (postStatus !== "DELETE") {
            if (!validateForm()) return;
        }

        const formDataToSend = new FormData();
        formDataToSend.append('user_id', getUserDetails("Id"));
        formDataToSend.append('branch_id', getUserDetails("branchId"));

        if (postStatus !== "DELETE") {
            formDataToSend.append('property_id', formData.property_id);
            formDataToSend.append('date_became_vacant', formData.date_became_vacant);
            formDataToSend.append('advertised_on', formData.advertised_on || '');
            formDataToSend.append('move_in_ready', formData.move_in_ready ? 1 : 0);
            formDataToSend.append('cleaning_completed', formData.cleaning_completed ? 1 : 0);
            formDataToSend.append('repairs_completed', formData.repairs_completed ? 1 : 0);
            formDataToSend.append('vacancy_status', formData.vacancy_status);
            formDataToSend.append('notes', formData.notes || '');
            formDataToSend.append('market_price', formData.market_price || 0);
        }

        if (postStatus === "UPDATE" || postStatus === "DELETE") {
            formDataToSend.append('updateId', updateId);
        }

        try {
            let result;
            if (postStatus === "ADD") {
                result = await apiService.create(APIVacancyStore, formDataToSend);
            } else if (postStatus === "UPDATE") {
                result = await apiService.update(APIVacancyUpdate, formDataToSend);
            } else if (postStatus === "DELETE") {
                result = await apiService.delete(APIVacancyDelete, formDataToSend);
            }

            if (result && result.success) {
                showToast("Success", result.message, "success");
                handleCloseAdd();
                handleCloseDelete();
                fetchVacancies();
                fetchStatistics();
            }
        } catch (error) {
            console.error("API Error:", error);
        }
    };

    const getStatusColor = (status) => {
        const option = vacancyStatusOptions.find(opt => opt.id === status);
        return option?.color || 'default';
    };

    const getStatusIcon = (status) => {
        const option = vacancyStatusOptions.find(opt => opt.id === status);
        return option?.icon || <Pending />;
    };

    const getStatusText = (status) => {
        const option = vacancyStatusOptions.find(opt => opt.id === status);
        return option ? option.name : status;
    };

    const getPlatformIcon = (platform) => {
        const option = advertisedPlatforms.find(opt => opt.id === platform);
        return option?.icon || <Campaign />;
    };

    const getPlatformName = (platform) => {
        const option = advertisedPlatforms.find(opt => opt.id === platform);
        return option ? option.name : platform;
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-UG', {
            style: 'currency',
            currency: 'UGX',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(amount || 0);
    };

    const getDaysOnMarketBadge = (days) => {
        if (days <= 7) return { color: 'success', label: 'New' };
        if (days <= 30) return { color: 'info', label: 'Normal' };
        if (days <= 60) return { color: 'warning', label: 'Concern' };
        return { color: 'error', label: 'Critical' };
    };

    // Filtered data
    const filteredData = pageState.pageData.filter(record => {
        const matchesSearch = searchTerm === '' ||
            record.property_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            record.advertised_on?.toLowerCase().includes(searchTerm.toLowerCase());

        const matchesStatus = !filters.vacancy_status || 
            record.vacancy_status === filters.vacancy_status;

        const matchesProperty = !filters.property_id || 
            record.property_id?.toString() === filters.property_id;

        const matchesReady = filters.move_in_ready === '' || 
            record.move_in_ready === (filters.move_in_ready === 'ready');

        let matchesDate = true;
        if (filters.date_from && record.date_became_vacant) {
            matchesDate = matchesDate && record.date_became_vacant >= filters.date_from;
        }
        if (filters.date_to && record.date_became_vacant) {
            matchesDate = matchesDate && record.date_became_vacant <= filters.date_to;
        }

        const matchesDaysMin = !filters.days_on_market_min || 
            record.days_on_market >= parseInt(filters.days_on_market_min);
        const matchesDaysMax = !filters.days_on_market_max || 
            record.days_on_market <= parseInt(filters.days_on_market_max);

        return matchesSearch && matchesStatus && matchesProperty && 
               matchesReady && matchesDate && matchesDaysMin && matchesDaysMax;
    });

    // Pagination
    const handleChangePage = (event, newPage) => setPage(newPage);
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    if (permissionLoading) {
        return <LoadingState message="Loading permissions..." variant="medical" size="large" fullPage />;
    }

    if (loading) {
        return <LoadingState message="Loading Vacancy Data..." variant="medical" size="large" fullPage />;
    }

    if (error) {
        return <ErrorState error={error} onRetry={fetchVacancies} title="Unable to Load Vacancy Data" variant="medical" fullPage retryText="Retry Loading" />;
    }

    return (
        <Container maxWidth="xl" sx={{ py: 3 }}>
            {/* Statistics Cards */}
            {statistics && (
                <Grid container spacing={3} sx={{ mb: 3 }}>
                    <Grid item xs={12} sm={6} md={3}>
                        <Paper elevation={2} sx={{ p: 2, borderRadius: 3 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Box>
                                    <Typography variant="h6" color="text.secondary">Active Vacancies</Typography>
                                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: theme.palette.primary.main }}>
                                        {statistics.active_vacancies || 0}
                                    </Typography>
                                </Box>
                                <Avatar sx={{ bgcolor: theme.palette.primary.light, width: 56, height: 56 }}>
                                    <MeetingRoom sx={{ fontSize: 32 }} />
                                </Avatar>
                            </Box>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Paper elevation={2} sx={{ p: 2, borderRadius: 3 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Box>
                                    <Typography variant="h6" color="text.secondary">Avg Days on Market</Typography>
                                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: theme.palette.warning.main }}>
                                        {statistics.avg_days_on_market || 0}
                                    </Typography>
                                </Box>
                                <Avatar sx={{ bgcolor: theme.palette.warning.light, width: 56, height: 56 }}>
                                    <AccessTime sx={{ fontSize: 32 }} />
                                </Avatar>
                            </Box>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Paper elevation={2} sx={{ p: 2, borderRadius: 3 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Box>
                                    <Typography variant="h6" color="text.secondary">Move-In Ready</Typography>
                                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: theme.palette.success.main }}>
                                        {statistics.move_in_ready_count || 0}
                                    </Typography>
                                </Box>
                                <Avatar sx={{ bgcolor: theme.palette.success.light, width: 56, height: 56 }}>
                                    <CheckCircle sx={{ fontSize: 32 }} />
                                </Avatar>
                            </Box>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Paper elevation={2} sx={{ p: 2, borderRadius: 3 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Box>
                                    <Typography variant="h6" color="text.secondary">Potential Revenue Loss</Typography>
                                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: theme.palette.error.main }}>
                                        {formatCurrency(statistics.potential_revenue_loss || 0)}
                                    </Typography>
                                </Box>
                                <Avatar sx={{ bgcolor: theme.palette.error.light, width: 56, height: 56 }}>
                                    <MoneyOff sx={{ fontSize: 32 }} />
                                </Avatar>
                            </Box>
                        </Paper>
                    </Grid>
                </Grid>
            )}

            {/* Action Buttons */}
            <Paper elevation={2} sx={{ p: 3, mb: 3, borderRadius: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: theme.palette.primary.main, flexShrink: 0 }}>
                        Property Vacancy Management ({recordsCount(pageState.pageData.length)} Total)
                    </Typography>

                    <Box sx={{ display: 'flex', gap: 1, flexShrink: 0 }}>
                        {hasPermission('ADD') && (
                            <Button
                                variant="contained"
                                color="warning"
                                startIcon={<AddIcon />}
                                onClick={handleOpenAdd}
                                sx={{ textTransform: 'none', borderRadius: '8px' }}
                            >
                                Add Vacancy
                            </Button>
                        )}
                        {hasPermission('VIEW') && (
                            <Button
                                variant="contained"
                                color="info"
                                startIcon={<FilterIcon />}
                                onClick={handlefilterOptions}
                                sx={{ textTransform: 'none', borderRadius: '8px' }}
                            >
                                View Options
                            </Button>
                        )}
                        {hasPermission('EXPORT') && (
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<GetApp />}
                                onClick={handleExportClick}
                                sx={{ textTransform: 'none', borderRadius: '8px' }}
                            >
                                Export Data
                            </Button>
                        )}
                        <Button
                            variant="outlined"
                            color="info"
                            startIcon={<RefreshIcon />}
                            onClick={() => { fetchVacancies(); fetchStatistics(); }}
                            sx={{ textTransform: 'none', borderRadius: '8px' }}
                        >
                            Refresh
                        </Button>
                    </Box>

                    <Paper sx={{
                        width: '300px',
                        p: '2px 8px',
                        display: 'flex',
                        alignItems: 'center',
                        marginLeft: 'auto',
                        borderRadius: '8px',
                        background: theme.palette.primary.light
                    }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Search vacancies..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            InputProps={{
                                startAdornment: <Search sx={{ mr: 1, color: 'white' }} />,
                                sx: {
                                    '& fieldset': { border: 'none' },
                                    fontSize: '0.875rem',
                                    color: 'white',
                                    '& input': { color: 'white', '&::placeholder': { color: 'rgba(255,255,255,0.7)', opacity: 1 } }
                                }
                            }}
                            size="small"
                        />
                    </Paper>
                </Box>
            </Paper>

            {/* Export Menu */}
            <Menu anchorEl={exportAnchorEl} open={Boolean(exportAnchorEl)} onClose={handleExportClose}>
                <MenuItem onClick={handleExportExcel} sx={{ gap: 1 }}><TableChart fontSize="small" color="success" /> Export to Excel (.xlsx)</MenuItem>
                <MenuItem onClick={handleExportPDF} sx={{ gap: 1 }}><PictureAsPdf fontSize="small" color="error" /> Export to PDF (.pdf)</MenuItem>
            </Menu>

            {/* Vacancies Table */}
            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
                <Paper elevation={2} sx={{ borderRadius: 3, overflow: 'hidden' }}>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow sx={{ backgroundColor: theme.palette.primary.main, '& th': { color: 'white', fontWeight: 'bold', fontSize: '0.95rem' } }}>
                                    <TableCell>#</TableCell>
                                    <TableCell>Property</TableCell>
                                    <TableCell>Vacant Since</TableCell>
                                    <TableCell>Days on Market</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Advertised On</TableCell>
                                    <TableCell>Ready</TableCell>
                                    <TableCell>Market Price</TableCell>
                                    <TableCell align="center">Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((record, index) => {
                                    const daysBadge = getDaysOnMarketBadge(record.days_on_market);
                                    return (
                                        <TableRow key={record.id || index} hover sx={{ '&:nth-of-type(odd)': { backgroundColor: theme.palette.action.hover } }}>
                                            <TableCell><Chip label={page * rowsPerPage + index + 1} color="primary" size="small" /></TableCell>
                                            <TableCell>
                                                <Typography variant="body2" sx={{ fontWeight: 'bold' }}>{record.property_name}</Typography>
                                                <Typography variant="caption" color="text.secondary">{record.property_address}</Typography>
                                            </TableCell>
                                            <TableCell>{record.date_became_vacant}</TableCell>
                                            <TableCell>
                                                <Chip
                                                    label={`${record.days_on_market} days`}
                                                    color={daysBadge.color}
                                                    size="small"
                                                    icon={<AccessTime />}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <Chip
                                                    icon={getStatusIcon(record.vacancy_status)}
                                                    label={getStatusText(record.vacancy_status)}
                                                    color={getStatusColor(record.vacancy_status)}
                                                    size="small"
                                                />
                                            </TableCell>
                                            <TableCell>
                                                {record.advertised_on && (
                                                    <Chip
                                                        icon={getPlatformIcon(record.advertised_on)}
                                                        label={getPlatformName(record.advertised_on)}
                                                        size="small"
                                                        variant="outlined"
                                                    />
                                                )}
                                            </TableCell>
                                            <TableCell>
                                                {record.move_in_ready ? (
                                                    <Chip icon={<CheckCircle />} label="Ready" color="success" size="small" />
                                                ) : (
                                                    <Chip icon={<Pending />} label="Not Ready" color="warning" size="small" />
                                                )}
                                            </TableCell>
                                            <TableCell>
                                                <Typography variant="body2" sx={{ fontWeight: 'bold', color: theme.palette.success.main }}>
                                                    {formatCurrency(record.market_price)}
                                                </Typography>
                                                <Typography variant="caption">/month</Typography>
                                            </TableCell>
                                            <TableCell align="center">
                                                {hasPermission('VIEW') && (
                                                    <Tooltip title="View Details"><IconButton onClick={() => handleOpenView(record)} color="primary"><ViewIcon /></IconButton></Tooltip>
                                                )}
                                                {hasPermission('PRINT') && (
                                                    <Tooltip title="Print"><IconButton onClick={() => handlePrintVacancy(record)} color="info"><Print /></IconButton></Tooltip>
                                                )}
                                                {hasPermission('EDIT') && (
                                                    <>
                                                        <Tooltip title="Edit"><IconButton onClick={() => handleOpenEdit(record)} color="secondary"><EditIcon /></IconButton></Tooltip>
                                                        {!record.move_in_ready && (
                                                            <Tooltip title="Mark Ready"><IconButton onClick={() => handleOpenMarkReady(record)} color="success"><DoneAll /></IconButton></Tooltip>
                                                        )}
                                                        <Tooltip title="Update Status"><IconButton onClick={() => handleOpenStatusUpdate(record)} color="warning"><TrendingFlat /></IconButton></Tooltip>
                                                    </>
                                                )}
                                                {hasPermission('DELETE') && (
                                                    <Tooltip title="Delete"><IconButton onClick={() => handleOpenDelete(record)} color="error"><Delete /></IconButton></Tooltip>
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination rowsPerPageOptions={[5, 10, 25, 50, 100]} component="div" count={filteredData.length} rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage} sx={{ mt: 2 }} />
                    {filteredData.length === 0 && (
                        <Box sx={{ textAlign: 'center', py: 8, color: 'text.secondary' }}>
                            <MeetingRoom sx={{ fontSize: 60, mb: 2 }} />
                            <Typography variant="h6">No vacancies found</Typography>
                            <Typography variant="body2">Try adjusting your search query</Typography>
                        </Box>
                    )}
                </Paper>
            </motion.div>

            {/* Filter Dialog */}
            <Dialog open={filterOptions} TransitionComponent={Transition} fullWidth maxWidth="sm" onClose={handleCloseOptions}>
                <DialogTitle sx={{ textAlign: 'center' }}>Filter Options</DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, p: 2 }}>
                        <Button variant="outlined" color="primary" startIcon={<RefreshIcon />} onClick={clearFilters}>Show All Vacancies</Button>
                        <Divider>OR</Divider>
                        <Typography variant="subtitle1" sx={{ textAlign: 'center' }}>Filter Vacancies</Typography>
                        <Box>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel>Vacancy Status</InputLabel>
                                    <Select name="vacancy_status" value={filters.vacancy_status} onChange={handleFilterChange} label="Vacancy Status">
                                        <MenuItem value="">All Status</MenuItem>
                                        {vacancyStatusOptions.map(item => <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            </Grid><br/>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel>Property</InputLabel>
                                    <Select name="property_id" value={filters.property_id} onChange={handleFilterChange} label="Property">
                                        <MenuItem value="">All Properties</MenuItem>
                                        {properties.map(property => <MenuItem key={property.id} value={property.id}>{property.property_name}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            </Grid><br/>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel>Move-In Ready</InputLabel>
                                    <Select name="move_in_ready" value={filters.move_in_ready} onChange={handleFilterChange} label="Move-In Ready">
                                        <MenuItem value="">All</MenuItem>
                                        <MenuItem value="ready">Ready</MenuItem>
                                        <MenuItem value="not_ready">Not Ready</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth label="Date From" name="date_from" type="date" value={filters.date_from} onChange={handleFilterChange} InputLabelProps={{ shrink: true }} />
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth label="Date To" name="date_to" type="date" value={filters.date_to} onChange={handleFilterChange} InputLabelProps={{ shrink: true }} />
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth label="Min Days on Market" name="days_on_market_min" type="number" value={filters.days_on_market_min} onChange={handleFilterChange} />
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth label="Max Days on Market" name="days_on_market_max" type="number" value={filters.days_on_market_max} onChange={handleFilterChange} />
                            </Grid>
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button color="error" onClick={handleCloseOptions} variant="contained">Close</Button>
                    <Button onClick={applyFilters} color="primary" variant="contained">Apply Filters</Button>
                </DialogActions>
            </Dialog>

            {/* Add/Edit Vacancy Dialog */}
            <Dialog open={openAdd} onClose={handleCloseAdd} TransitionComponent={Transition} fullWidth maxWidth="sm" scroll="paper">
                <DialogTitle sx={{ textAlign: 'center' }}><b>{postStatus === "ADD" ? "Add Vacancy" : "Edit Vacancy"}</b></DialogTitle>
                <DialogContent>
                    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
                        <Box>
                            <Grid item xs={12}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 1 }}>Vacancy Information</Typography>
                            </Grid><br/>
                            <Grid item xs={12}>
                                <FormControl fullWidth required>
                                    <InputLabel>Select Property *</InputLabel>
                                    <Select name="property_id" value={formData.property_id} onChange={handleInputChange} label="Select Property *">
                                        <MenuItem value="">Select a property</MenuItem>
                                        {properties.map(prop => (
                                            <MenuItem key={prop.id} value={prop.id}>
                                                {prop.property_name} - {prop.property_address}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth label="Date Became Vacant *" name="date_became_vacant" type="date" value={formData.date_became_vacant} onChange={handleInputChange} required InputLabelProps={{ shrink: true }} />
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel>Advertised On</InputLabel>
                                    <Select name="advertised_on" value={formData.advertised_on} onChange={handleInputChange} label="Advertised On">
                                        <MenuItem value="">Not Advertised</MenuItem>
                                        {advertisedPlatforms.map(item => <MenuItem key={item.id} value={item.id}><Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>{item.icon} {item.name}</Box></MenuItem>)}
                                    </Select>
                                </FormControl>
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth label="Market Price (UGX)" name="market_price" type="number" value={formData.market_price} onChange={handleInputChange} InputProps={{ startAdornment: <InputAdornment position="start"><AttachMoney /></InputAdornment> }} />
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel>Vacancy Status</InputLabel>
                                    <Select name="vacancy_status" value={formData.vacancy_status} onChange={handleInputChange} label="Vacancy Status">
                                        {vacancyStatusOptions.map(item => <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            </Grid><br/>
                            <Grid item xs={12}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 1, mt: 2 }}>Readiness Status</Typography>
                            </Grid><br/>
                            <Grid item xs={12}>
                                <FormControlLabel control={<Switch name="move_in_ready" checked={formData.move_in_ready} onChange={handleInputChange} color="primary" />} label="Move-In Ready" />
                                <FormControlLabel control={<Switch name="cleaning_completed" checked={formData.cleaning_completed} onChange={handleInputChange} color="info" />} label="Cleaning Completed" sx={{ ml: 3 }} />
                                <FormControlLabel control={<Switch name="repairs_completed" checked={formData.repairs_completed} onChange={handleInputChange} color="warning" />} label="Repairs Completed" sx={{ ml: 3 }} />
                            </Grid><br/>
                            <Grid item xs={12}>
                                <TextField fullWidth label="Notes" name="notes" value={formData.notes} onChange={handleInputChange} multiline rows={3} placeholder="Additional notes about the vacancy..." />
                            </Grid>
                        </Box>
                        <DialogActions sx={{ mt: 3, px: 0 }}>
                            <Button color="error" onClick={handleCloseAdd} variant="contained">Cancel</Button>
                            <Button type="submit" color="primary" variant="contained">{postStatus === "ADD" ? "Create Vacancy" : "Update Vacancy"}</Button>
                        </DialogActions>
                    </Box>
                </DialogContent>
            </Dialog>

            {/* Mark Ready Dialog */}
            <Dialog open={readyDialogOpen} onClose={() => setReadyDialogOpen(false)} TransitionComponent={Transition}>
                <DialogTitle sx={{ textAlign: 'center' }}>Mark Property as Move-In Ready</DialogTitle>
                <DialogContent>
                    <Box sx={{ p: 2 }}>
                        <Typography variant="body1" gutterBottom>Confirm that the following tasks are completed:</Typography>
                        <FormControlLabel control={<Switch checked={readyItems.cleaning_completed} onChange={(e) => setReadyItems({ ...readyItems, cleaning_completed: e.target.checked })} color="primary" />} label="Cleaning Completed" />
                        <FormControlLabel control={<Switch checked={readyItems.repairs_completed} onChange={(e) => setReadyItems({ ...readyItems, repairs_completed: e.target.checked })} color="warning" />} label="Repairs Completed" sx={{ ml: 3 }} />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button color="error" onClick={() => setReadyDialogOpen(false)} variant="contained">Cancel</Button>
                    <Button onClick={handleMarkReady} color="success" variant="contained">Mark as Ready</Button>
                </DialogActions>
            </Dialog>

            {/* Update Status Dialog */}
            <Dialog open={statusUpdateDialogOpen} onClose={() => setStatusUpdateDialogOpen(false)} TransitionComponent={Transition} fullWidth maxWidth="sm">
                <DialogTitle sx={{ textAlign: 'center' }}>Update Vacancy Status</DialogTitle>
                <DialogContent>
                    <Box sx={{ p: 2 }}>
                        <Typography variant="body1" gutterBottom>Update status for <strong>{selectedRecord?.property_name}</strong></Typography>
                        <FormControl fullWidth sx={{ mt: 2 }}>
                            <InputLabel>New Status</InputLabel>
                            <Select value={newStatus} onChange={(e) => setNewStatus(e.target.value)} label="New Status">
                                {vacancyStatusOptions.map(item => <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button color="error" onClick={() => setStatusUpdateDialogOpen(false)} variant="contained">Cancel</Button>
                    <Button onClick={handleUpdateStatus} color="primary" variant="contained">Update Status</Button>
                </DialogActions>
            </Dialog>

            {/* View Dialog */}
            <Dialog open={openView} onClose={handleCloseView} TransitionComponent={Transition} fullWidth maxWidth="sm">
                <DialogTitle sx={{ textAlign: 'center' }}><b>Vacancy Details</b></DialogTitle>
                <DialogContent>
                    {selectedRecord && (
                        <Box>
                            <Box>
                                <Grid item xs={12}><Typography variant="h6" color="primary">Vacancy Information</Typography></Grid><br/>
                                <Grid item xs={12} sm={6}><Typography variant="subtitle2"><b>Vacancy ID:</b> {selectedRecord.vacancy_id}</Typography></Grid><br/>
                                <Grid item xs={12} sm={6}><Typography variant="subtitle2"><b>Date Vacant:</b> {selectedRecord.date_became_vacant}</Typography></Grid><br/>
                                <Grid item xs={12} sm={6}><Typography variant="subtitle2"><b>Days on Market:</b> {selectedRecord.days_on_market} days</Typography></Grid><br/>
                                <Grid item xs={12} sm={6}><Typography variant="subtitle2"><b>Status:</b> <Chip icon={getStatusIcon(selectedRecord.vacancy_status)} label={getStatusText(selectedRecord.vacancy_status)} color={getStatusColor(selectedRecord.vacancy_status)} size="small" /></Typography></Grid><br/>
                                {selectedRecord.advertised_on && <Grid item xs={12}><Typography variant="subtitle2"><b>Advertised On:</b> {getPlatformName(selectedRecord.advertised_on)}</Typography></Grid>}<br/>
                                <Grid item xs={12}><Typography variant="h6" color="primary" sx={{ mt: 2 }}>Readiness Status</Typography></Grid><br/>
                                <Grid item xs={12} sm={4}><Typography variant="subtitle2"><b>Move-In Ready:</b> {selectedRecord.move_in_ready ? <CheckCircle color="success" /> : <Cancel color="error" />}</Typography></Grid><br/>
                                <Grid item xs={12} sm={4}><Typography variant="subtitle2"><b>Cleaning Completed:</b> {selectedRecord.cleaning_completed ? <CheckCircle color="success" /> : <Cancel color="error" />}</Typography></Grid><br/>
                                <Grid item xs={12} sm={4}><Typography variant="subtitle2"><b>Repairs Completed:</b> {selectedRecord.repairs_completed ? <CheckCircle color="success" /> : <Cancel color="error" />}</Typography></Grid><br/>
                                <Grid item xs={12}><Typography variant="h6" color="primary" sx={{ mt: 2 }}>Property Details</Typography></Grid><br/>
                                <Grid item xs={12} sm={6}><Typography variant="subtitle2"><b>Property:</b> {selectedRecord.property_name}</Typography></Grid><br/>
                                <Grid item xs={12} sm={6}><Typography variant="subtitle2"><b>Address:</b> {selectedRecord.property_address}</Typography></Grid><br/>
                                <Grid item xs={12}><Typography variant="subtitle2"><b>Market Price:</b> {formatCurrency(selectedRecord.market_price)}/month</Typography></Grid><br/>
                                {selectedRecord.notes && <Grid item xs={12}><Typography variant="subtitle2"><b>Notes:</b> {selectedRecord.notes}</Typography></Grid>}<br/>
                                <Grid item xs={12}><Typography variant="h6" color="primary" sx={{ mt: 2 }}>System Information</Typography></Grid><br/>
                                <Grid item xs={12} sm={6}><Typography variant="subtitle2"><b>Created:</b> {formatCreatedAtDate(selectedRecord.created_at)}</Typography></Grid><br/>
                                <Grid item xs={12} sm={6}><Typography variant="subtitle2"><b>Last Updated:</b> {formatCreatedAtDate(selectedRecord.updated_at)}</Typography></Grid>
                            </Box>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button color="error" onClick={handleCloseView} variant="contained">Close</Button>
                    {hasPermission('PRINT') && selectedRecord && <Button onClick={() => handlePrintVacancy(selectedRecord)} color="info" variant="contained"><Print sx={{ mr: 1 }} /> Print</Button>}
                </DialogActions>
            </Dialog>

            {/* Delete Confirmation Dialog */}
            <Dialog open={openDelete} onClose={handleCloseDelete} TransitionComponent={Transition}>
                <DialogTitle sx={{ textAlign: 'center' }}>Delete Vacancy Record</DialogTitle>
                <DialogContent>
                    <Typography variant="body1" sx={{ textAlign: 'center', mb: 2 }}>Are you sure you want to delete this vacancy record?</Typography>
                    {selectedRecord && <Typography variant="h6" sx={{ textAlign: 'center' }}>{selectedRecord.property_name}</Typography>}
                    <Typography variant="body2" color="error" sx={{ textAlign: 'center', mt: 2 }}>Warning: This action cannot be undone!</Typography>
                </DialogContent>
                <DialogActions><Button color="error" onClick={handleCloseDelete} variant="contained">Cancel</Button><Button onClick={handleSubmit} color="primary" variant="contained">Confirm Delete</Button></DialogActions>
            </Dialog>

            <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
                <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>{snackbar.message}</Alert>
            </Snackbar>
        </Container>
    );
};

export default VacancyManagement;